import { z } from 'zod'

export const paramsSchema = z.object({
  destinationId: z.number(),
  searchListType: z.enum(['list', 'facet', 'results']),
  page: z.number(),
})

export type paramsType = z.infer<typeof paramsSchema>
